import { TTRouteConfig } from "@tt-app/models";
import { ROUTES } from "@tt-app/constants";

const { LEARNING_HISTORY } = ROUTES;

export const learningHistoryRoutes: TTRouteConfig[] = [
  {
    name: LEARNING_HISTORY.SUMMARY.NAME,
    path: LEARNING_HISTORY.SUMMARY.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () =>
      import(
        /*webpackChunkName: "tt-core" */ "@tt-app/views/learningHistory/LearningHistorySummary.vue"
      )
  },
  {
    name: LEARNING_HISTORY.EXERCISE_LOGS.NAME,
    path: LEARNING_HISTORY.EXERCISE_LOGS.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () =>
      import(
        /*webpackChunkName: "tt-core" */ "@tt-app/views/learningHistory/LearningHistoryExerciseLogs.vue"
      )
  }
];
